/*
Monotype Foundry Platform API
Version 1.0.0

Definition: PatchDropShipRequest

Properties:
  projectName: string (required), minLength: 3, maxLength: 100
*/

var PatchDropShipRequest = (function () {
  function validatePatchDropShipRequest (arg) {
    // Validate projectName
    if (!arg.projectName) {
      throw new Error('PatchDropShipRequest.projectName: Missing property')
    }
    if (arg.projectName && !(typeof arg.projectName === 'string')) {
      throw new Error('PatchDropShipRequest.projectName: Wrong type: Got \'' + (typeof arg.projectName) + '\', but expected: \'string\'')
    }
    if (arg.projectName && !(arg.projectName.length >= 3)) {
      throw new Error('PatchDropShipRequest.projectName: Minimum length 3, but got: ' + arg.projectName.length)
    }
    if (arg.projectName && !(arg.projectName.length <= 100)) {
      throw new Error('PatchDropShipRequest.projectName: Maximum length 100, but got: ' + arg.projectName.length)
    }
  }
  function buildPatchDropShipRequest (arg) {
    var PatchDropShipRequest = arg
    // Complete projectName
    // Expected Type: string
    PatchDropShipRequest.projectName = PatchDropShipRequest.projectName || ''
    return PatchDropShipRequest
  }
  return {
    validate: validatePatchDropShipRequest,
    build: buildPatchDropShipRequest
  }
})()

module.exports = PatchDropShipRequest
